export enum RightOffCanvasState {
  hidden = 0,
  filter = 1
}
